import gql from "graphql-tag";

export default gql`
  mutation ($itemCode: String!) {
    toggleBasketItem(itemCode: $itemCode) {
      state
    }
  }`;